import { GlobalErrorType, IApiHeader } from "./appStoreTypes";

interface ITranslation {
  language: string;
  title: string;
  description: string;
}

export interface ICategory {
  categoryId: string;
  categoryKey: string;
  translation: Pick<ITranslation, "title" | "language">;
  badge?: boolean;
}

export interface ICategoryState {
  list: ICategory[];
  selectedId?: string;
  isLoadingList: boolean;
}

export interface ICategoryNewProject {
  categoryId: string;
  newProjects: string[];
}

export interface IProject {
  width: number;
  height: number;
  ratio: string;
  duration: string;
  imagePath: string;
  videoPath: string;
  filePath: string;
  projectId: string;
  publishedAt: string;
  translation: ITranslation;
  share: { dynamicLink: string };
  likeCounts: number;
  downloadCounts: number;
  assetLevel: number;
  projectLevel: number;
}

export interface IFeedState {
  page: number;
  display: number;
  list: IProject[];
  isLoadingList: boolean;
}

export const initialFeedState: IFeedState = {
  page: 1,
  display: 20,
  list: [],
  isLoadingList: true,
};

export interface IFeedStore {
  categoryState: ICategoryState;
  onGetCategoryList: (apiHeader: IApiHeader) => void;
  onSelectedCategory: (apiHeader: IApiHeader, id?: string) => void;
  onGetCategoryNewProject: (apiHeader: IApiHeader) => void;

  feedState: IFeedState;
  onUpdateFeedList: (apiHeader: IApiHeader, page?: number) => void;

  feedErrorState: GlobalErrorType;
  onUpdateFeedError: (type: GlobalErrorType) => void;

  onUpdateLikeCounts: (id: string) => void;
  onUpdateUnlikeCounts: (id: string) => void;
  onUpdateDownloadCounts: (id: string) => void;
}
